// extracted by mini-css-extract-plugin
export var chip = "_a1-0";
export var filterDropdown = "_a1-5";
export var filterItem = "_a1-6";
export var icon = "_a1-1";
export var removeButton = "_a1-3";
export var removeIcon = "_a1-4";
export var separator = "_a1-2";